const GID_PATTERN = /^gid:\/\/shopify\/([A-Za-z0-9_-]+)\/([0-9]+)$/

export const parseGid = (gid: string) => {
  const [, resource, idString] = gid.match(GID_PATTERN) ?? []
  if (!resource || !idString) {
    throw new Error(`Invalid GID: ${gid}`)
  }
  return {
    resource,
    id: Number(idString),
  }
}

declare global {
  interface Window {
    Shopify?: {
      routes: {
        root: string
      }
    }
  }
}

export const addVariantToCart = async (variantId: string) => {
  if (!window.Shopify) {
    throw new Error('Shopify is not loaded')
  }

  const formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  }
  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(formData),
  })

  if (!response.ok) {
    throw new Error(`Failed to add product to cart: ${response.statusText}`)
  }

  return response.json()
}
